/**
 * @generated SignedSource<<6c408a8c5638b57cd8bfdca8bb9f5546>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductExpireBatchQuery$variables = {
  productExpireBatchId: string;
};
export type ProductExpireBatchQuery$data = {
  readonly currentStore: {
    readonly productExpireBatch: {
      readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatch_ProductExpireBatch">;
    };
  };
};
export type ProductExpireBatchQuery = {
  response: ProductExpireBatchQuery$data;
  variables: ProductExpireBatchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productExpireBatchId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "productExpireBatchId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "expireAtDate",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductExpireBatchQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "currentStore",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "StoreProductExpireBatch",
                "kind": "LinkedField",
                "name": "productExpireBatch",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ProductExpireBatch_ProductExpireBatch"
                  }
                ],
                "storageKey": null
              },
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductExpireBatchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StoreProductExpireBatch",
            "kind": "LinkedField",
            "name": "productExpireBatch",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreProduct",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreProductExpireBatch",
                    "kind": "LinkedField",
                    "name": "activeExpireBatches",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "partNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageUrl",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreProductExpireBatchAction",
                "kind": "LinkedField",
                "name": "activeAction",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreProductExpireBatchAction",
                "kind": "LinkedField",
                "name": "actions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreZonedDate",
                    "kind": "LinkedField",
                    "name": "startAtDate",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "timezone",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreZonedDate",
                "kind": "LinkedField",
                "name": "deadlineAtDate",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "958f70e78e666a3434eca3cd04961c34",
    "id": null,
    "metadata": {},
    "name": "ProductExpireBatchQuery",
    "operationKind": "query",
    "text": "query ProductExpireBatchQuery(\n  $productExpireBatchId: ID!\n) {\n  currentStore {\n    productExpireBatch(id: $productExpireBatchId) {\n      ...ProductExpireBatch_ProductExpireBatch\n      id\n    }\n    id\n  }\n}\n\nfragment ProductExpireBatchActionList_productExpireBatch on StoreProductExpireBatch {\n  id\n  activeAction {\n    id\n  }\n  actions {\n    id\n    status\n    ...ProductExpireBatchAction_StoreProductExpireBatchAction\n  }\n  product {\n    id\n  }\n}\n\nfragment ProductExpireBatchAction_StoreProductExpireBatchAction on StoreProductExpireBatchAction {\n  id\n  label\n  status\n  startAtDate {\n    isoString\n    timezone\n    ...StoreRelativeZonedDate_StoreZonedDate\n  }\n}\n\nfragment ProductExpireBatchDatePicker_StoreProduct on StoreProduct {\n  activeExpireBatches {\n    id\n    expireAtDate {\n      isoString\n    }\n  }\n}\n\nfragment ProductExpireBatchProductPreview_StoreProduct on StoreProduct {\n  id\n  name\n  partNumber\n  imageUrl\n}\n\nfragment ProductExpireBatchStatusFooter_productExpireBatch on StoreProductExpireBatch {\n  status\n  id\n  product {\n    id\n  }\n  deadlineAtDate {\n    isoString\n  }\n}\n\nfragment ProductExpireBatch_ProductExpireBatch on StoreProductExpireBatch {\n  id\n  expireAtDate {\n    isoString\n  }\n  product {\n    id\n    ...ProductExpireBatchDatePicker_StoreProduct\n    ...ProductExpireBatchProductPreview_StoreProduct\n  }\n  ...ProductExpireBatchActionList_productExpireBatch\n  ...ProductExpireBatchStatusFooter_productExpireBatch\n}\n\nfragment StoreRelativeZonedDate_StoreZonedDate on StoreZonedDate {\n  isoString\n  timezone\n}\n"
  }
};
})();

(node as any).hash = "9a375bbdaf699ab5990f4cbb1d9aeafd";

export default node;
